import { EmailAiSuggestionButtonFormModel } from '@/components/emailWindow/components/newEmail/components/aiSuggestionButton/components/dialog/model/EmailAiSuggestionButtonForm.model.ts';

export type NewEmailTranslation = {
  body: {
    bcc: string;
    body: string;
    button: {
      aiSuggestion: string;
    };
    cc: string;
    dialog: {
      aiSuggestion: {
        button: {
          cancel: string;
          submit: string;
        };
        form: Record<keyof EmailAiSuggestionButtonFormModel, string> & {
          instructionPlaceholder: string;
        };
        toast: { provideInstructions: string };
      };
    };
    dropzone: {
      button: {
        reset: string;
        upload: string;
      };
      disabled: string;
      label: string;
    };
    emailValidationFailed: string;
    subject: string;
    to: string;
    tooltip: {
      aiSuggestion: string;
    };
  };
  header: {
    button: {
      send: string;
    };
    tooltip: {
      close: string;
      dock: string;
      floating: string;
      minimize: string;
    };
  };
  previousMessages: string;
};

export const newEmailTranslation: NewEmailTranslation = {
  body: {
    bcc: 'Ukryta kopia',
    body: 'Treść',
    button: {
      aiSuggestion: 'Generuj z AI',
    },
    cc: 'Kopia',
    dialog: {
      aiSuggestion: {
        button: {
          cancel: 'Anuluj',
          submit: 'Pobierz podpowiedź maila',
        },
        form: {
          addAttachments: 'Dodaj załączniki',
          addCafeRoyalInfo: 'Dodać informację firmową?',
          contentType: 'Typ wiadomości',
          instruction: 'Dodatkowe wytyczne',
          instructionPlaceholder:
            'Opcjonalne dodatkowe wytyczne, które będą uwzględnione przy generowaniu treści wiadomości',
        },
        toast: { provideInstructions: 'Podaj wytyczne dla generowanej wiadomości' },
      },
    },
    dropzone: {
      button: {
        reset: 'Usuń',
        upload: 'Dodaj',
      },
      disabled: 'Trwa wgrywanie pliku...',
      label: 'Upuść tu plik lub kliknij, aby wybrać z komputera',
    },
    emailValidationFailed: 'Niepoprawny adres email',
    subject: 'Temat',
    to: 'Do',
    tooltip: {
      aiSuggestion: 'Podaj przynajmniej jednego odbiorcę',
    },
  },
  header: {
    button: {
      send: 'Wyślij',
    },
    tooltip: {
      close: 'Zamknij',
      dock: 'Przypnij do okna',
      floating: 'Otwórz w oknie',
      minimize: 'Zminimalizuj',
    },
  },
  previousMessages: 'Wiadomości w wątku',
};
